/// <reference path="../types/index.d.ts" />

import '../client_forms/tcacontactwed/style.css';
import FormStructure from './tcacontactwed/form_structure';

export default FormStructure;